import { IconButton } from '@/shared/ui';
import { PlusIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';
import { CHART_CELL_GUTTER_CLASS, CHART_ROW_START_CLASS } from '../DashboardPresetGrid/chartLayout';

type Props = {
  /** Место стоит отдельной строкой в конце сетки: заводимая им диаграмма начинает новую строку */
  startsRow: boolean;
  onAdd: () => void;
};

/**
 * Место под новую диаграмму: знак «плюс» без подписи в конце строки, где осталась ширина под
 * диаграмму, либо отдельной строкой в конце сетки — тогда прижатый к её левому краю.
 *
 * Величины диаграммы место не занимает: оно заметно меньше и умещается в любой свободный остаток
 * строки. По высоте место стоит посреди своей строки — так знак виден на уровне ряда диаграмм,
 * какой бы высокой ни была строка.
 */
export const AddChartTile: FC<Props> = ({ startsRow, onAdd }) => {
  const { t } = useTranslation('qualityDashboard');
  const label = startsRow ? t('presets.editor.addChartInNewRow') : t('presets.editor.addChart');

  return (
    <div
      className={cn(
        'flex items-center self-center lg:col-span-3',
        CHART_CELL_GUTTER_CLASS,
        startsRow && CHART_ROW_START_CLASS,
      )}
    >
      <IconButton
        variant="secondary"
        size="icon"
        label={label}
        icon={<PlusIcon className="size-4" />}
        onClick={onAdd}
        className="border border-dashed"
      />
    </div>
  );
};
